import React from 'react';

import { hookFormFieldHoc, HookFormFieldCoreProps } from '../field.hoc';

interface InputTextProps extends HookFormFieldCoreProps {
  type?: 'text' | 'password' | 'search' | 'tel' | 'url' | 'email';
  placeholder?: string;
}

const InputText: React.FC<InputTextProps> = ({
  type,
  maxLength: _maxLength,
  minLength: _minLength,
  field,
  placeholder,
  disabled = false,
}) => {
  const maxLength = typeof _maxLength === 'object' ? _maxLength.value : _maxLength;
  const minLength = typeof _minLength === 'object' ? _minLength.value : _minLength;

  return (
    <input
      {...field}
      placeholder={placeholder}
      maxLength={maxLength}
      value={field?.value || ''}
      minLength={minLength}
      type={type}
      disabled={disabled}
    />
  );
};

export default hookFormFieldHoc(InputText);
